// Meta Pixel (Dataset ID: 1179655543886825) is initialized once in public/index.html,
// which also fires the automatic PageView. Everything below only sends custom events.

const firedOnceKeyPrefix = "meta_pixel_fired_"

const isPixelReady = (): boolean => typeof window !== "undefined" && typeof window.fbq === "function"

export const trackMetaEvent = (event: string, params?: Record<string, unknown>): void => {
  if (!isPixelReady()) return

  try {
    window.fbq("track", event, params)
  } catch (e) {
    // Pixel must never break the flow it is measuring (ad blockers, network errors, ...)
    console.warn("Meta Pixel event could not be sent:", event, e)
  }
}

// Sends the event at most once per browser session, so re-mounting a page
// or navigating back and forth does not create duplicate events.
export const trackMetaEventOnce = (event: string, params?: Record<string, unknown>): void => {
  if (!isPixelReady()) return

  const key = `${firedOnceKeyPrefix}${event}`
  try {
    if (window.sessionStorage.getItem(key)) return
    window.sessionStorage.setItem(key, "1")
  } catch {
    // sessionStorage may be unavailable (private mode); fall through and still send the event
  }

  trackMetaEvent(event, params)
}

// What we call a "lead" (contact details submitted on Start Your Journey) is reported
// by the Meta ads panel as "Complete Registration". Both standard events are sent from
// the exact same moment so the two numbers always match 1:1 and the ads platform
// optimizes on the real conversion instead of a page landing.
export const trackMetaLead = (params?: Record<string, unknown>): void => {
  trackMetaEventOnce("Lead", params)
  trackMetaEventOnce("CompleteRegistration", params)
}

declare global {
  interface Window {
    fbq: any
  }
}
